<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/PicURB/tc-custom/9781627795432.jpg?1737776857991" alt="This image is the cover for the book A Week without Tuesday, Tuesday McGillycuddy Adventures"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">A Week without Tuesday, Tuesday McGillycuddy Adventures
      </h1>
      <p class="bookDescription body article font2">
        <p><b>A charming adventure full of magic and mystery, set in the land where stories come from.</b><br/><br/>Something is broken in the land of story. Real and imaginary worlds are colliding—putting everything and everyone in grave peril. Tuesday and Baxterr, at the request of the Librarian, and with the help of Vivienne Small, venture to find the Gardener—the one person who can stop this catastrophe. On their way, they'll meet friends and foes, and discover strengths they didn't know they had. Will they be able to save the land of story?<br/><br/><i>A Week Without Tuesday</i> by Angelica Banks, with illustrations by Stevie Lewis, is the charming sequel to <i>Finding Serendipity</i>, a middle grade novel full of all the magic, mystery, and adorable illustrations readers have come to expect from this series.<br/><br/>This title has Common Core connections.<br/><br/>“All the worlds are fully rendered and themes of imagination, courage, family, sacrifice, and friendship are beautifully explored. Fans of Edith Nesbit, Michael Ende’s <i>The Neverending Story</i>, and Roderick Townley’s <i>The Great Good Thing</i> have a new home with Angelica Banks.” —<i>Booklist</i>, starred review <br/><br/>“Banks’s wondrously whimsical language helps transport readers into this imaginative world. . . . Creative young authors as well as fantasy lovers will enjoy this inventive book.” —<i>School Library Journal</i></p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Angelica Banks
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Henry Holt and Company
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?57ca8eb0